import React from 'react';

import { BREAKPOINTS, unit } from '@zego/theme';

import ContentContainer from '@zego/components/ContentContainer';
import StaticBackgroundImage from '@zego/components/StaticBackgroundImage';

const Hero = ({ children, image, promo, bgBlend = 'transparent' }) => (
  <StaticBackgroundImage
    src={image}
    css={{
      position: 'relative',
      marginTop: -100,
      [BREAKPOINTS.normal]: {
        marginTop: -(50 + 100),
      },
    }}
  >
    <div
      css={{
        backgroundColor: bgBlend,
        height: '100%',
        paddingTop: 100,
        [BREAKPOINTS.medium]: {
          paddingBottom: 24,
        },
        [BREAKPOINTS.normal]: {
          paddingTop: 50 + 100,
        },
      }}
    >
      {promo}
      <ContentContainer
        css={{
          paddingTop: unit(1),
          paddingBottom: unit(1),
        }}
      >
        {children}
      </ContentContainer>
    </div>
  </StaticBackgroundImage>
);

export default Hero;
